// --------------------------------------------------------------
// Created On: 2021-09-30
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import validateNickname from "../../../utilities/validateNickname";
import styles from "./AssetListRow.module.scss";

// A single asset in an asset list.
export default function AssetListRow(props: Props): Component {
  return (
    <div className="p-2" data-test="asset-list-row">
      {props.name} {validateNickname(props.nickname, props.name) ? `(${props.nickname})` : ""}
      {props.isMigrating === true && (
        <span data-test="migrating-asset-marker" className={`${styles.tag} ${styles.migrationTag}`}>
          Migrating
        </span>
      )}
      {props.lastConfigSuccessful === false && (
        <span data-test="failed-config-asset-marker" className={`${styles.tag} ${styles.failedConfigTag}`}>
          Failed Config
        </span>
      )}
      {props.isRented === true && (
        <span data-test="rented-asset-marker" className={`${styles.tag} ${styles.rentalTag}`}>
          Rental
        </span>
      )}
    </div>
  );
}

interface Props {
  assetId: number;
  name: string;
  nickname: string;
  isRented?: boolean;
  isMigrating?: boolean;
  lastConfigSuccessful?: boolean;
}
